import { render } from "./LibraryFormItem.vue?vue&type=template&id=ecf7c48a&scoped=true"
import script from "./LibraryFormItem.vue?vue&type=script&lang=js"
export * from "./LibraryFormItem.vue?vue&type=script&lang=js"

import "./LibraryFormItem.vue?vue&type=style&index=0&id=ecf7c48a&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf7c48a"]])

export default __exports__